import type { AxiosResponse } from 'axios';
import type { ApiResponse } from './types';
import routes from '@/config/routes';
import { v3Get, v3Post } from './axios.instance.V3';
import type { ICreateApplication, INavigationHistory } from '@/store/types';

const url = {
  getLiveCampaignsSummary: () => `${routes.backendUrl.gigs.getLiveCampaignList}`,
  getLiveCampaignDetail: (campaignId: number) => `${routes.backendUrl.gigs.getLiveCampaignDetail}/${campaignId}/detail`,
  getComingSoonGigs: () => `${routes.backendUrl.gigs.getFutureCampaign}`,
  getAppliedGigs: () => `${routes.backendUrl.gigs.getAppliedgigs}`,
  getContractRequirements: (gigId: number, countryId: number) =>
    `${routes.backendUrl.gigs.getContractRequirement}/${gigId}/country/${countryId}/active`,
  createApplication: () => `${routes.backendUrl.gigApplication.createApplication}`,
  createNavigationHistory: () => `${routes.backendUrl.gigApplication.createNavigationHistory}`,
};

const getLiveCampaignsSummary = (): ApiResponse => v3Get(url.getLiveCampaignsSummary());
const getLiveCampaignDetail = (campaignId: number): ApiResponse => v3Get(url.getLiveCampaignDetail(campaignId));
const getComingSoonGigs = (): ApiResponse => v3Get(url.getComingSoonGigs());
const getAppliedGigs = (): ApiResponse => v3Get(url.getAppliedGigs());
const getContractRequirements = (gigId: number, countryId: number): ApiResponse =>
  v3Get(url.getContractRequirements(gigId, countryId));
const createApplication = async (payload: ICreateApplication): Promise<AxiosResponse> => {
  return await v3Post(`${url.createApplication()}`, payload);
};
const createNavigationHistory = async (payload: INavigationHistory): Promise<AxiosResponse> => {
  return await v3Post(`${url.createNavigationHistory()}`, payload);
};

export const gigApis = {
  getLiveCampaignsSummary,
  getLiveCampaignDetail,
  getComingSoonGigs,
  getAppliedGigs,
  getContractRequirements,
  createApplication,
  createNavigationHistory,
};
